import {Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {ILoaderModel, LoaderState} from '../../models/loader/loader.redux';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
   loader$: Observable<ILoaderModel> = this.store.select<ILoaderModel>(LoaderState.getLoaderStatus);

  constructor(
    private store: Store
  ) { }

  ngOnInit(): void {
  }
}
